import type { IDeviceControlOption } from '@/Interfaces/Device.interface';
import ToggleButton from '@/components/Buttons/ToggleButton';
import { FormLabel } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { DeviceIcons } from './constants';

const DeviceList = () => {
  const { control } = useFormContext();

  const watchDevices: IDeviceControlOption[] = useWatch({
    control,
    name: 'devices',
  });
  if (!watchDevices?.length) {
    return null;
  }
  return (
    <div className='flex flex-1 flex-col'>
      <FormLabel aria-label='Devices'>Devices</FormLabel>
      <div className='flex flex-nowrap gap-x-2 gap-y-2 h-[32px]'>
        {watchDevices.map(device => {
          const Icon = DeviceIcons[device.value];
          return (
            <ToggleButton
              key={device.value}
              label={device.label}
              value={device.value}
              startAdornment={Icon ? <Icon width='20' /> : null}
              selected
              disabled
            />
          );
        })}
      </div>
    </div>
  );
};

export default DeviceList;
